var render = function render(){var _vm=this,_c=_vm._self._c;return _c('benefit-notification-box-base',{attrs:{"icon-path":_vm.iconText,"description":_vm.description,"title":_vm.title,"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }